import React from "react";
import "./NutrientInfo.css";

const nutrients = require("../../../Data/nutrients.json");
const units = require("../../../Data/nutrientUnits.json");

const NutrientRow = ({
  name,
  nutrient_id,
  amount,
  unit,
  header,
  evenRow,
  language,
}) => {
  return header ? (
    <div className="nutrientRow">
      <p className="nutrientHeader">{name}</p>
      <p className="nutrientHeader">{amount}</p>
    </div>
  ) : (
    <div
      className="nutrientRow"
      style={
        evenRow ? { backgroundColor: "white" } : { backgroundColor: "#e3e3e3" }
      }
    >
      <p className="nutrientText">{nutrients[language][nutrient_id]}</p>
      <p className="nutrientText">{`${amount} ${units[unit]}`}</p>
    </div>
  );
};

export default NutrientRow;
